<template>
    <div id="card_rate_header_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="CardRateHeader" v-if="$route.params.id > 0" >Update Rate Header</span>
                    <span class="page-title" id="CardRateHeader"  v-else>Add Rate Header</span>

                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="goPreviousPath" >
                        <i class="fp-back"> </i>  Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content discount-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="ContractForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="contract_type_id">Contract Type:</label>
                                        <v-select v-model="contract_type_id" name="contract_type_id" placeholder="Select Contract Type."
                                                label="text"
                                                :options="contractTypeArr">
                                        </v-select>
                                        <div class="field-error">{{ contract_type_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="code">Scope:</label>
                                        <input type="text" class="form-control" v-model="scope" id="scope" placeholder="Enter Scope" name="scope">
                                        <div class="field-error">{{ scope_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="base_scope">Base Rate:</label>
                                        <v-select v-model="base_scope" name="base_scope"
                                            label="text" :filterable="false" :options="baseScopeArr"
                                            @search="onSearchBaseRate"
                                            placeholder="Select Base Rate" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Base Rate...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <!-- <v-select v-model="base_scope" name="base_scope" placeholder="Select Base Scope."
                                                label="text"
                                                :options="baseScopeArr">
                                        </v-select> -->
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="cpi_code_id">Customer Map Type:</label>
                                        <v-select v-model="map_type" name="map_type" placeholder="Select Map Type."
                                                label="text"
                                                :options="mapTypeArr" @input="onSelectCustomer($event,'type')">
                                        </v-select>
                                        <div class="field-error">{{map_type_error}}</div>
                                    </div>
                                    <div v-if="map_type && map_type.value == 'one'" class="col form-group">
                                        <label class="control-label require" for="customer_id">Customer:</label>
                                        <v-select v-model="customer_id" name="customer_id"
                                            label="text" :filterable="false" :options="customerArr"
                                            @search="onSearchCustomer" @input="onSelectCustomer($event,'customer')"
                                            placeholder="Select Customer" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Customer...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ customer_error_msg }}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="effective_date">Effective Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="effective_date" name="effective_date" v-model="effective_date" :config="optionsDate"></date-picker>
                                            <label for="effective_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{ effective_date_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label">Expiry Date:</label>
                                        <div class="input-group">
                                            <date-picker type="text" id="expiry_date" name="expiry_date" placeholder="Expiry Date" class="form-control" v-model="expiry_date" :config="optionsDate"></date-picker>
                                            <label for="expiry_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{expiry_date_error_msg}}</div>
                                    </div>

                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <button type="submit" id="createCardRateHeaderBtn" v-if="$route.params.id > 0 && map_type && map_type == 'multiple'" class="btn btn-primary pull-right" v-on:click.prevent="toggleList">
                                    <i class="fp-reload"> </i>  {{buttonText}}
                                </button>
                                <div class="btn-groups1 text-right mt-2 mb-3">
                                    <button type="submit" id="createCardRateHeaderBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateCardRateHeader" >
                                        <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createCardRateHeaderBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateCardRateHeader" >
                                        <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueCardRateHeaderBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateCardRateHeader(flag='Save and Continue')" >
                                        <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelCardRateHeaderBtn" class="btn btn-tertiary" v-on:click.prevent="BackHeaderList">
                                        <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                            <!-- <template v-show="loadselectedList && map_type && map_type == 'multiple'">
                                <card-rates-customer-list :customerVal="'cardRateCustomerList'" ></card-rates-customer-list>
                                <p>&nbsp;</p>
                            </template> -->
                            <template v-if="map_type && map_type.value == 'multiple'">
                                <data-table-filter-config :moduleName="'cardRateCustomerList'" @cancelSelection="cancelAll"></data-table-filter-config>
                                    <div class="field-error">{{multiple_customer_error_msg}}</div>
                                    <section class="bg-white data-table">
                                            <custom-pagination
                                                :page-changed="onPageChange"
                                                :per-page-changed="onPerPageChange" :moduleName="'CustomerList'" :position="'top'">
                                            </custom-pagination>
                                            <vue-good-table
                                                ref="listcardRateCustomerTable"
                                                mode="remote"
                                                title="Customer"
                                                @on-page-change="onPageChange"
                                                @on-selected-rows-change="selectionChanged"
                                                @on-column-filter="onColumnFilter"
                                                @on-per-page-change="onPerPageChange"
                                                @on-sort-change="onSortChange"
                                                @on-select-all="onSelectAll"
                                                @on-row-click="onRowClick"
                                                :totalRows="totalRecords"
                                                :columns="userColumns"
                                                :rows="rows"
                                                :pagination-options="{
                                                    enabled: false,
                                                    setCurrentPage:listCurrentPage,
                                                    perPage: perPage,
                                                }"
                                                :select-options="{
                                                enabled: true,
                                                selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
                                                selectionInfoClass: 'custom-class',
                                                selectionText: 'rows selected',
                                                clearSelectionText: 'clear',
                                                }"
                                                :search-options="{
                                                enabled: false,
                                                }">

                                            </vue-good-table>

                                            <custom-pagination
                                                :page-changed="onPageChange"
                                                :per-page-changed="onPerPageChange"
                                                >
                                            </custom-pagination>
                                    </section>
                            </template>
                            <!-- if map type is multiple then button not display so displayed it -->
                            <div style="clear:both"></div>


                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';

import EventBus from "././event-bus";


import {dataTableMixins} from '../mixins/dataTableMixins';

export default {
  name: "ContractCreate",
  components: {
    
    
    customAssetPagination: () => import('@/components/layout/CustomPagination'),
    cardRatesCustomerList: () => import('@/components/CardRatesCustomerList'),
    
  },
  metaInfo() {
        return {
            title: (this.$route.params.id > 0)? "Update Card Rate Header | " +process.env.COPYRIGHT_NAME : "Create Card Rate Header | " +process.env.COPYRIGHT_NAME
        }
  },
  mixins:[commonMixins,contractMixins,dataTableMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    contract_type_id: null,
    contractTypeArr: [],
    customer_id: null,
    customerArr: [],
    effective_date: "",
    expiry_date: "",
    baseScopeArr:[],
    mapTypeArr: [
        {
            text: "All",
            value: "all"
        },
        {
            text: "Multiple",
            value: "multiple"
        },
        {
            text: "One",
            value: "one"
        },
    ],
    map_type_error:'',
    scope_error_msg:'',
    base_scope:'',
    scope:'',
    map_type:'',
    loading:false,
    editContract:false,
    contract_type_error_msg: "",
    code_error_msg: "",
    customer_error_msg: "",
    location_error_msg: "",
    effective_date_error_msg: "",
    contract_term_error_msg:"",
    expiry_date_error_msg: "",
    optionsDate: {
        format: 'MM/DD/YYYY',
        useCurrent: false,
    },
    rows: [],
    totalRecords: 0,
    userColumns:[],
    columns: [
            {
                label: 'Code',
                field: 'code',
                filterable: true,
                fpFieldType:"text",
                width:'140px',
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterFn: this.onColumnFilter,
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Name',
                field: 'name',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Name", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Email',
                field: 'email',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Email", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Phone',
                field: 'work_phone',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Phone", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'City',
                field: 'city',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "City", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'State',
                field: 'state',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "State", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Stage',
                field: 'stage',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "All", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ['Potential', 'Account Pending', 'Credit Denied', 'New', 'Existing'],
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Created At',
                field: 'created_at',
                fpFieldType:"date",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Status',
                field: 'status',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "All", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ['Unverified','Active', 'Inactive'],
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Outstanding AR',
                field: 'outstanding_ar',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                type:'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Outstanding AR", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
        ],
        selectedArray:[],
        newList:true,
        loadselectedList:false,
        buttonText:'Add Customer',
        multiple_customer_error_msg:'',
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'scope_header_create' ) {
                        self.cantAccessPage = true;

                    }
                }
            }

        }

  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadFieldData(['rentalContractType']);
        var path = window.location.pathname;
        var segments = path.split("/");

        if (segments[3]) {
            self.loadScopeHeader();
        }else{
            self.loadList();
        }
  },
  methods: {
    cancelAll: function (cancelAll) {
      this.$refs.listcardRateCustomerTable.unselectAllInternal();
    },

    onSearchCustomer(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'customer', '');
        }
    },
    onSearchBaseRate(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'base_scope', '');
        }
    },

    BackHeaderList() {
      var self = this;
      self.$router.push("/scope-header/list");
    },

    CreateCardRateHeader(flag) {
        var self = this;
        var error = false;

        self.contract_type_error_msg = "";
        self.customer_error_msg = "";
        self.effective_date_error_msg = "";
        self.expiry_date_error_msg = "";
        self.multiple_customer_error_msg = "";
        self.scope_error_msg = '';
        self.map_type_error = '';

        if (self.contract_type_id == null || !self.contract_type_id.value) {
            self.contract_type_error_msg = "Contract Type require.";
            error = true;
        }
        if (self.map_type == null || !self.map_type.value) {
            self.map_type_error = "Map Type require.";
            error = true;
        }

        if (self.map_type && self.map_type.value == 'one' && (self.customer_id == null || !self.customer_id.value)) {
            self.customer_error_msg = "Customer Name is require.";
            error = true;
        }
        if (self.map_type && self.map_type.value == 'multiple' && (!self.selectedArray.length)) {
            self.multiple_customer_error_msg = "Customer Selection is require.";
            error = true;
        }

        if (!self.effective_date || self.effective_date == null || self.effective_date == "") {
            self.effective_date_error_msg = "Effective Date require.";
            error = true;
        }
        if (!self.scope || self.scope == null || self.scope == "") {
            self.scope_error_msg = "Scope Name require.";
            error = true;
        }

        // if (!self.expiry_date || self.expiry_date == null || self.expiry_date == "") {
        //     self.expiry_date_error_msg = "Expiry Date Required.";
        //     error = true;
        // }

        if (Date.parse(self.effective_date) > Date.parse(self.expiry_date)) {
            alert("Expiry Date should not be earlier than Effective Date");
            error = true;
        }

        if ((Date.parse(self.effective_date) >= Date.parse(self.termination_date)) || (Date.parse(self.expiry_date) <= Date.parse(self.termination_date))) {
            alert("Termination Date should be between Effective Date and Expiry Date");
            error = true;
        }

        if (!error) {

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createCardRateHeaderBtn").val("Updating ...");
                $("#createCardRateHeaderBtn").prop("disabled", true);
                $("#cancelCardRateHeaderBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueCardRateHeaderBtn").val("Saving ...");
                    $("#createCardRateHeaderBtn").prop("disabled", true);
                    $("#createAndContinueCardRateHeaderBtn").prop("disabled", true);
                    $("#cancelCardRateHeaderBtn").prop("disabled",true);

                }else{

                    $("#createCardRateHeaderBtn").val("Saving ...");
                    $("#createCardRateHeaderBtn").prop("disabled", true);
                    $("#createAndContinueCardRateHeaderBtn").prop("disabled", true);
                    $("#cancelCardRateHeaderBtn").prop("disabled",true);
                }

            }

            var fields = $("#ContractForm").serializeArray();
            fields.push({ name: "id", value: segments[3] });
            fields.push({name: "contract_type_id", value: self.contract_type_id.value});
            if (self.map_type.value == 'one'){
                fields.push({name: "customer_id", value: self.customer_id.value});
            }else if (self.map_type.value == 'multiple'){
                fields.push({name: "customer_id", value: JSON.stringify(self.selectedArray)});
            }
            fields.push({name: "map_type", value: self.map_type.value});
            if (self.base_scope && self.base_scope.value){

                fields.push({name: "base_card_rate_id", value: self.base_scope.value});

            }

            if (segments[3]){
                fields.push({name: "id", value: segments[3]});
            }else{
                fields.push({name: "id", value:0});
            }
            $.ajax({
                url: process.env.ROOT_API + "/card-rate-header/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;

                    if (segments[3])
                    {
                        self.editContract = true;
                        $("#createCardRateHeaderBtn").val("Update");
                        $("#createCardRateHeaderBtn").prop("disabled", false);
                        $("#cancelCardRateHeaderBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueCardRateHeaderBtn").val("Save and Continue");
                            $("#createCardRateHeaderBtn").prop("disabled", false);
                            $("#createAndContinueCardRateHeaderBtn").prop("disabled", false);
                            $("#cancelCardRateHeaderBtn").prop("disabled",false);

                        }else{

                            $("#createCardRateHeaderBtn").val("Save");
                            $("#createCardRateHeaderBtn").prop("disabled", false);
                            $("#createAndContinueCardRateHeaderBtn").prop("disabled", false);
                            $("#cancelCardRateHeaderBtn").prop("disabled",false);

                        }
                    }
                    if (data.code == 201){
                        self.$swal('','Default rate is already added for this contract type please select customer if it is not default','warning');
                        return;
                    }
                    if (data.status == "success") {

                        if ( flag == "Save and Continue") {

                            self.contract_type_id = null;
                            self.customer_id = null;
                            self.effective_date = "";
                            self.expiry_date = "";
                            self.scope = "";
                            self.base_scope = '';
                            self.map_type = "";

                        } else {
                            // alert(data.content.contract_type_id + data.content.ctCode);
                            // if(!self.editContract){
                            //     var params = encodeURI("contractName=" + data.content.code + "&contractId=" + data.content.id + "&contractTypeId=" + self.contract_type_id.value + "&contractTypeCode=" + self.contract_type_id.text);
                            //     self.$router.push("/contractassetdetail/add?"+params);
                            // }
                            // else{
                                self.BackHeaderList();
                            // }
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";

                            if (data.message == "errMsgContract") {

                                // err +=  "Contract " + data.content[0].code + " exits for this Contract Type " + self.titleCase(data.content[0].contName) + " & Customer " + self.titleCase(data.content[0].custName);
                                err +=  self.titleCase(data.content[0].contName) + "Contract Type already exists for this Customer Name " + self.titleCase(data.content[0].custName);

                            } else if (data.message == "errMsgEffectiveMonth"){

                                err += "Insert First Effective CPI Code for this month.";

                            } else {

                                for (var i = 0; i < data.content.length; i++) {

                                    if (data.content[i] == "The frequency must be a number.") {
                                        err += "The Cpi frequency must be a number." + "<br>";
                                    } else {
                                        err += data.content[i] + "<br>";
                                    }

                                }
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createCardRateHeaderBtn").val("Update");
                        $("#createCardRateHeaderBtn").prop("disabled", false);
                        $("#cancelCardRateHeaderBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueCardRateHeaderBtn").val("Save and Continue");
                            $("#createCardRateHeaderBtn").prop("disabled", false);
                            $("#createAndContinueCardRateHeaderBtn").prop("disabled", false);
                            $("#cancelCardRateHeaderBtn").prop("disabled",false);

                        }else{

                            $("#createCardRateHeaderBtn").val("Save");
                            $("#createCardRateHeaderBtn").prop("disabled", false);
                            $("#createAndContinueCardRateHeaderBtn").prop("disabled", false);
                            $("#cancelCardRateHeaderBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,false,'contract-data-create')
                }
            });
        }else{
            self.errorValidationFocus();
        }
    },

    loadScopeHeader() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/card-rate-header/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {

                    self.contract_type_id = {value: data.content.contract_type_id, text:data.content.contract_type};
                    if (data.content.map_type == 'multiple'){
                        self.selectedArray = data.content.customer_id;

                    }else{
                        self.customer_id = {value: data.content.customer_id, text: self.titleCase(data.content.customer)};

                    }
                    self.effective_date = data.content.effective_date;
                    self.expiry_date = data.content.expiry_date;
                    self.map_type = {text:self.titleCase(data.content.map_type),value:data.content.map_type};
                    self.base_scope = data.content.base_card_rate;

                    self.scope = data.content.scope;
                    self.newList = false;
                    self.loadselectedList = true;
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'load-contract-data')
            }
        });
    },
    toggleList:function(){
        var self = this;
        if (self.newList){
            self.newList = false;
            self.loadselectedList = true;
            self.buttonText = 'Add Customer';

        }else{
            self.newList = true;
            self.loadselectedList = false;
            self.buttonText = 'Selected Customer';
            self.loadList();
        }
    },
    onPageChange(params) {
        var self = this;
        this.updateParams({page: params.currentPage});
        this.listCurrentPage = params.currentPage;

        if(self.map_type && self.map_type.value == 'multiple' ){
            this.loadList();
        }
      },
      onRowClick(params){
           var self = this;
            setTimeout(function(){
                $('.vgt-selection-info-row').css({'display':'none'});
            },1);
                if(self.map_type && self.map_type.value == 'multiple' ){
                self.selectedAssetArray=[];
                if ($.inArray(params.row.id, self.selectedArray) != -1)
                {
                        // self.selectedArray.splice(i,1);
                    var index = self.selectedArray.indexOf(params.row.id);
                    if (index > -1) {
                        self.selectedArray.splice(index, 1);
                    }
                }else{
                    self.selectedArray.push(params.row.id);
                }
            }
            // console.log("CustomerArr"+self.selectedArray);
      },
      selectionChanged(param) {
            var self = this;
            if(param.selectedRows.length == 100) {
              EventBus.$emit('clear-selection', false);
            } else {
              EventBus.$emit('clear-all-flags', false);
            }
            // console.log(self.computed.selectedRows);
            // var rowData = self.$refs['my-table'].selectedRows;
            // console.log(rowData);
        },
      findElementIndex(array, attr, value) {
            for(var i = 0; i < array.length; i += 1) {
                if(array[i][attr] === value) {
                return i;
                }
            }
            return -1;
      },
      loadList() {

        var self = this;

        self.loading = true;
        //get selected customers ids

        var selectedRows = [];
            //because on first load list not initialize
            // var data = this.$refs['listCustomerTable'].selectedRows;
            // for ( var i = 0; i < data.length; i++ ) {
            //     selectedRows.push(this.$refs['listCustomerTable'].selectedRows[i].id)
            // }

        // self.dropDownPerPage=[];
        var fields = {

            page: self.serverParams.page,
            perPage: self.serverParams.perPage,
            filters: self.serverParams.columnFilters,
            sort: self.serverParams.sort,
            flag: self.flag,
            selectedRows:selectedRows,
            action:self.action,
            selectedAll:self.serverParams.selectedAll

        };

        self.firstLoad = 1;
        $.ajax({
            url: process.env.ROOT_API + "/customer/list",
            type: "POST",
            data: fields,
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                // console.log(data);
                if (data.status == "success") {
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;

                        for(var k=0;k< self.rows.length;k++){
                            if ($.inArray(self.rows[k].id, self.selectedArray) >= 0) {
                                    self.$set(self.rows[k], 'vgtSelected', true);
                                }
                        }
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'customer-list-error')

            }
        });
    },
    onSelectCustomer:function(evt,flag){
        var self = this;
        if ( flag == 'customer' && self.customer_id != null ) {

            var r = confirm("Do you wants to append Customer No. after Scope name? Please remove existing Customer No. from scope name if exist.");
            if (r == true) {
                self.scope = self.scope+' | '+self.customer_id.code;
            }

        }else{
            self.newList = true;
            self.loadselectedList = true;
            self.loadList();
        }

    },

    titleCase(str) {
        if (str == null){
            return;
        } else{
            var value = str.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/CardRateHeaderCreate.vue